import Constant from '@/const';
import axios from 'axios';

const exportMjknReporting = async params => {
  try {
    const response = await axios.get(
      Constant.apiUrl.concat('/report/mjkn/export'),
      {
        params,
      },
    );
    return response;
  } catch (error) {
    const err = error;
    throw err;
  }
};

export default exportMjknReporting;
